
export default function getIndex(state, eventId) {
  return state.events.findIndex((event) => event.id.toString() === eventId.toString());
}